document.addEventListener('DOMContentLoaded', () => {
  const initCustomAboutBrandStats = () => {
    const statsContainers = document.querySelectorAll('.custom-about-brand__stats');
    if (!statsContainers.length) return;

    statsContainers.forEach((statsContainer) => {
      let hasAnimated = false;

      const animateCountUp = () => {
        if (hasAnimated) return;
        hasAnimated = true;

        const statEls = statsContainer.querySelectorAll('[data-count-target]');

        statEls.forEach((el) => {
          const target = parseInt(el.getAttribute('data-count-target'), 10);
          const suffix = el.getAttribute('data-count-suffix') || '';

          if (isNaN(target) || target <= 0) {
            el.textContent = target + suffix;
            return;
          }

          const duration = 1800; // ms
          const startTime = performance.now();

          const easeOutQuad = (t) => t * (2 - t);

          const step = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeOutQuad(progress);
            const current = Math.round(easedProgress * target);

            el.textContent = current + suffix;

            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.textContent = target + suffix;
            }
          };

          requestAnimationFrame(step);
        });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                animateCountUp();
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.3 }
        );
        observer.observe(statsContainer);
      } else {
        animateCountUp();
      }
    });
  };

  initCustomAboutBrandStats();
});
